var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _ellipse, _path34, _path35, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgLogin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 456,
    height: 547,
    viewBox: "0 0 456 547",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.307 319.455C286.671 396.299 160.976 412.809 75.3785 350.272C-10.2192 287.735 -14.6271 140.612 52.093 82.5489C118.813 24.4861 321.943 242.612 304.307 319.455Z",
    fill: "url(#paint0_linear)",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.573 562.043C223.611 556.909 268.993 526.084 297.196 477.095C325.287 428.3 329.237 373.816 311.805 333.206C267.767 338.34 222.385 369.165 194.182 418.154C166.091 466.949 162.141 521.433 179.573 562.043Z",
    fill: "url(#paint1_linear)",
    fillOpacity: 0.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.664 583.605C220.012 539.283 238.282 474.243 220.003 411.121C201.724 347.998 151.527 302.785 92.0476 287.951C49.699 332.273 31.4292 397.313 49.7084 460.435C67.9875 523.557 118.185 568.771 177.664 583.605Z",
    fill: "url(#paint2_linear)",
    fillOpacity: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3363 613.685C78.1875 602.786 56.5137 580.65 53.89 562.569C52.7493 554.708 55.487 554.677 50.9013 549.545C43.0531 540.787 33.6458 536.483 30.4442 524.047C28.0335 514.656 27.5772 502.846 29.6381 493.334C31.1362 486.407 34.528 483.95 32.0412 477.423C28.1247 467.135 20.5427 460.428 18.6643 448.858C17.3638 440.862 18.1928 432.398 19.2727 424.34C20.0027 418.921 22.8926 415.937 24.2158 411.362C26.5961 403.147 19.6453 395.971 18.5122 387.296C17.2726 377.815 19.5236 367.361 21.4324 358C31.6382 359.311 40.3533 371.446 44.2394 380.144C47.076 386.482 45.7072 395.203 50.3537 399.891C53.8368 403.395 59.6317 403.81 63.1983 409.221C66.4228 414.12 68.4685 420.406 69.6777 426.066C72.1873 437.756 69.7613 447.856 69.7385 459.403C69.7157 470.075 78.986 476.82 84.9026 485.872C93.671 499.288 98.0971 514.618 99.9146 530.393C100.941 539.37 97.8689 552.673 101.618 559.923C104.257 565.026 110.379 568.749 112.98 574.454C115.976 581.027 116.25 589.137 115.862 596.274C115.071 610.858 104.66 615.305 91.3363 613.685Z",
    fill: "url(#paint3_linear)",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M102.869 576.771C112.395 568.852 128.097 552.769 129.998 539.632C130.825 533.92 128.841 533.898 132.163 530.169C137.849 523.806 144.665 520.679 146.984 511.644C148.731 504.82 149.061 496.239 147.568 489.329C146.483 484.296 144.026 482.511 145.827 477.769C148.665 470.294 154.158 465.42 155.519 457.014C156.461 451.204 155.86 445.054 155.078 439.201C154.549 435.263 152.455 433.095 151.497 429.771C149.772 423.802 154.808 418.589 155.629 412.286C156.527 405.397 154.896 397.801 153.513 391C146.119 391.953 139.805 400.769 136.99 407.089C134.935 411.694 135.926 418.03 132.56 421.436C130.037 423.982 125.838 424.284 123.254 428.215C120.918 431.775 119.436 436.342 118.56 440.455C116.742 448.948 118.499 456.286 118.516 464.675C118.532 472.429 111.816 477.33 107.53 483.907C101.177 493.655 97.9705 504.793 96.6537 516.255C95.9099 522.777 98.1358 532.442 95.4195 537.71C93.5077 541.417 89.0724 544.122 87.1881 548.268C85.0173 553.043 84.819 558.935 85.1 564.121C85.673 574.717 93.2157 577.948 102.869 576.771Z",
    fill: "url(#paint4_linear)",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 24,
    width: 261,
    height: 323,
    rx: 60,
    fill: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.2456 68.3204L87.6304 67.3968C96.9013 90.5563 113.087 111.6 136.189 130.527L118.732 151.735C95.6337 124.785 81.3957 96.9802 82.2456 68.3204Z",
    fill: "#B4BAC7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.7715 135.991H106.722C95.6127 108.98 90.0583 86.035 90.0583 67.1551L75.594 65C64.2265 83.2824 61.0163 105.792 58.7715 135.991Z",
    fill: "#DDE3E9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.288 65.0102C75.2899 65.0068 75.2918 65.0034 75.2937 65L76.2378 65C77.3676 65.0389 79.0884 65.109 81.4002 65.2103L84.8953 75.1984C85.265 87.3762 87.424 111.918 91.3723 148.823H59.9399C60.0223 151.372 60.1582 153.945 60.3475 156.541H36.9761C40.472 117.1 53.2388 86.5863 75.2764 65L75.288 65.0102V65.0102Z",
    fill: "#C7CCD7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.0162 116.209C62.9108 132.098 65.1505 143.051 68.7354 149.069H59.9481C59.5634 137.637 60.2528 126.684 62.0162 116.209V116.209Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.936 129.764L82.4352 122.559V129.764H66.936Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M150 55C150 52.7909 151.791 51 154 51H195C197.209 51 199 52.7909 199 55V75C199 77.2091 197.209 79 195 79H154C151.791 79 150 77.2091 150 75V55Z",
    fill: "#EEF1F8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M150 219C150 216.791 151.791 215 154 215H212C214.209 215 216 216.791 216 219V239C216 241.209 214.209 243 212 243H154C151.791 243 150 241.209 150 239V219Z",
    fill: "#EEF1F8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M32 57C32 54.7909 33.7909 53 36 53H60C62.2091 53 64 54.7909 64 57V60C64 62.2091 62.2091 64 60 64H32V57Z",
    fill: "#EEF1F8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M33 214C33 211.791 34.7909 210 37 210H61C63.2091 210 65 211.791 65 214V217C65 219.209 63.2091 221 61 221H33V214Z",
    fill: "#EEF1F8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M33 63H134C135.657 63 137 64.3431 137 66V157C137 158.657 135.657 160 134 160H36C34.3431 160 33 158.657 33 157V63Z",
    stroke: "#EEF1F8",
    strokeWidth: 2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M34 220H135C136.657 220 138 221.343 138 223V305C138 306.657 136.657 308 135 308H37C35.3431 308 34 306.657 34 305V220Z",
    stroke: "#EEF1F8",
    strokeWidth: 2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M150 90C150 87.7909 151.791 86 154 86H208C210.209 86 212 87.7909 212 90V110C212 112.209 210.209 114 208 114H154C151.791 114 150 112.209 150 110V90Z",
    fill: "#EEF1F8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M150 254C150 251.791 151.791 250 154 250H220C222.209 250 224 251.791 224 254V274C224 276.209 222.209 278 220 278H154C151.791 278 150 276.209 150 274V254Z",
    fill: "#EEF1F8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M150 124C150 121.791 151.791 120 154 120H232C234.209 120 236 121.791 236 124V144C236 146.209 234.209 148 232 148H154C151.791 148 150 146.209 150 144V124Z",
    fill: "#EEF1F8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M150 288C150 285.791 151.791 284 154 284H204C206.209 284 208 285.791 208 288V308C208 310.209 206.209 312 204 312H154C151.791 312 150 310.209 150 308V288Z",
    fill: "#EEF1F8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M150 159C150 156.791 151.791 155 154 155H244C246.209 155 248 156.791 248 159V179C248 181.209 246.209 183 244 183H154C151.791 183 150 181.209 150 179V159Z",
    fill: "#EEF1F8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M300.206 86.0009C307.59 86.9917 318.914 76.4634 323.653 71.0753C325.128 75.0481 327.979 83.366 327.587 84.8554C327.096 86.7172 310.216 99.3914 302.044 95.6447C295.507 92.6472 290.113 84.0043 288.233 80.0575C289.147 81.6258 292.821 85.0102 300.206 86.0009Z",
    fill: "url(#paint5_linear)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M300.879 60.7841C300.492 69.1797 311.945 77.8855 317.72 81.1889C313.868 84.1716 305.783 90.1589 304.262 90.2461C302.36 90.355 288.307 76.3322 291.386 66.1252C293.849 57.9596 302.051 49.0872 305.845 45.6718C304.351 47.211 301.267 52.3885 300.879 60.7841Z",
    fill: "url(#paint6_linear)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M339.477 311.684C337.966 282.947 324.997 268.831 318.702 265.364H309.259L295.567 335.317C295.252 371.553 295.567 449.036 299.344 469.076C304.066 494.127 334.755 546.591 339.477 570.696C343.254 589.98 341.05 598.267 339.477 600L394.245 594.801C394.56 588.499 390.468 572.586 386.691 555.098C382.097 533.827 358.834 463.877 352.224 434.1C345.614 404.323 341.365 347.605 339.477 311.684Z",
    fill: "url(#paint7_linear)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M249.911 349.181C252.172 329.131 266.872 278.723 273.94 256.025L312.575 244.676C313.988 259.335 317.663 292.341 321.056 307.095C325.296 325.537 311.161 349.181 312.575 375.189C313.988 401.196 303.152 451.321 292.315 470.709C283.646 486.219 288.703 556.929 292.315 590.345C291.059 593.182 283.646 598.384 264.045 596.492C244.445 594.601 232.007 591.606 228.237 590.345C235.462 556.613 248.591 482.719 243.314 456.995C236.718 424.84 247.084 374.243 249.911 349.181Z",
    fill: "url(#paint8_linear)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M391.158 308.582C392.666 301.771 390.529 289.031 389.273 283.513C380.79 282.252 365.145 281.054 370.423 286.351C377.021 292.973 367.125 299.122 363.826 308.582C361.187 316.15 358.957 361.242 358.171 382.842C356.915 389.148 355.155 402.707 358.171 406.491C361.187 410.275 363.198 418.158 363.826 421.627V406.491L373.722 412.64C376.863 417.212 383.147 425.411 383.147 421.627C383.147 416.897 376.549 406.491 370.423 399.396C365.522 393.72 366.182 385.995 367.125 382.842C374.507 360.926 389.65 315.393 391.158 308.582Z",
    fill: "url(#paint9_linear)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M187.977 134.883C192.14 143.579 201.38 149.219 205.48 150.952C205.48 156.939 203.682 169.762 196.492 173.165C189.302 176.568 185.927 171.747 185.139 168.911C180.724 161.35 171.137 143.39 168.109 132.048C164.325 117.869 161.487 86.2039 161.014 82.8956C160.635 80.249 168.109 80.2175 171.894 80.5325V62.1006L176.151 80.5325C178.043 82.5805 181.828 87.5272 181.828 90.9301C181.828 94.3329 178.043 100.225 176.151 102.745C178.359 109.835 183.814 126.187 187.977 134.883Z",
    fill: "url(#paint10_linear)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M313.912 148.164C317.721 141.388 317.403 130.91 316.769 126.519L333.907 124.166C336.129 135.459 339.24 159.551 333.907 165.574C328.575 171.597 312.96 165.574 305.819 161.809C306.93 160.084 310.104 154.939 313.912 148.164Z",
    fill: "url(#paint11_linear)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M309.377 100.895C312.597 87.9282 321.835 79.2839 326.052 76.5825C334.677 81.0204 353.652 91.6329 360.552 98.5792C369.177 107.262 341.577 126.364 330.652 132.732C321.912 137.826 310.91 134.854 306.502 132.732C306.119 127.522 306.157 113.861 309.377 100.895Z",
    fill: "url(#paint12_linear)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M340.632 149.567L307.443 150.964C281.999 217.218 266.737 241.468 250.335 280.074L342.978 291.962C341.613 306.098 342.964 310.603 340.632 325.361L401.763 347.215C401.546 266.884 381.871 201.125 342.738 149.937L340.653 149.551L340.632 149.567Z",
    fill: "#556FB5"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.141 217.936C340.916 249.719 334.155 274.37 326.424 289.998L343.277 292.261C346.129 266.479 347.015 241.757 345.141 217.936Z",
    fill: "#52489C"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M331.505 167.599L307.992 151.054C230.013 167.599 239.465 170.43 211.494 125.485L163.496 156.376C194.13 202.981 242.544 225.332 294.492 193.788C307.94 185.622 331.505 183.191 331.505 167.599Z",
    fill: "#556FB5"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M337.562 128.498C344.776 126.816 365.615 119.911 374.099 109.034C383.148 97.4319 379.661 88.2276 374.099 77.6025C368.537 66.9773 358.27 59.0942 349.529 55.994C340.789 52.8938 306.74 64.2283 295.414 58.8535C286.353 54.5537 282.758 45.4293 282.093 41.4046C281.353 45.7228 280.711 56.0136 284.064 62.6318C288.255 70.9045 299.068 87.294 312.1 90.7291C325.132 94.1642 321.278 76.0503 334.7 85.5615C340.244 89.4901 345.924 97.4842 345.577 105.599C345.577 105.599 351.208 107.544 350.73 111.324C350.242 115.184 341.57 120.484 337.562 128.498Z",
    fill: "url(#paint13_linear)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.9099,
    ry: 6.66491,
    transform: "matrix(-0.776584 -0.630014 -0.630014 0.776584 347.639 108.781)",
    fill: "#FFC19E"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.4036 227.569L87.1891 226.748C94.7277 253.396 133.461 271.561 135.839 281.523C136.711 285.176 134.081 287.023 135.439 288.135L129.219 292.689C128.166 291.46 125.918 293.708 121.224 292.135C116.53 290.563 82.4036 259.123 82.4036 227.569Z",
    fill: "#B4BAC7"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.4533 231.112C89.9016 266.392 110.296 275.391 105.754 289.544C102.002 301.232 66.0955 313.796 59.882 302.339C57.3669 297.702 56.2258 292.093 56.0963 285.996C54.5083 290.68 53.2523 294.713 52.3285 298.094C50.7347 303.927 44.5558 304.855 44.5558 307.102L36.4152 304.855C36.9673 301.802 33.1296 300.315 34.1586 293.495C38.7691 262.937 51.1565 240.786 71.3209 227.043L71.5295 224.059C71.6148 222.84 72.6726 221.92 73.8922 222.005L88.7982 223.048C90.0178 223.133 90.9373 224.191 90.852 225.411L90.4533 231.112Z",
    fill: "#C7CCD7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 8,
    width: 301,
    height: 363,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 173.898,
    y1: 137.214,
    x2: 120.494,
    y2: 375.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52489C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#556FB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 188.566,
    y1: 513.555,
    x2: 333.816,
    y2: 553.747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE74C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 186.368,
    y1: 524.851,
    x2: -34.0086,
    y2: 516.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4CFFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 58.6963,
    y1: 278.708,
    x2: 99.392,
    y2: 610.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#556FB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#556FB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 126.516,
    y1: 333.39,
    x2: 96.8659,
    y2: 574.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#556FB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#556FB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 320.46,
    y1: 68.2678,
    x2: 301.303,
    y2: 120.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD9F79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA6665"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 320.267,
    y1: 76.7366,
    x2: 268.223,
    y2: 64.6658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD9F79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA6665"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 338.077,
    y1: 245.041,
    x2: 341.298,
    y2: 600,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#556FB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554552,
    stopColor: "#272F7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 288.092,
    y1: 244.676,
    x2: 237.789,
    y2: 749.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#556FB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#132A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 374.091,
    y1: 282.432,
    x2: 374.091,
    y2: 422.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD89D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAF9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 183.24,
    y1: 62.1006,
    x2: 183.24,
    y2: 174.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD89D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAF9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 321.335,
    y1: 124.166,
    x2: 321.335,
    y2: 168.129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.512285,
    stopColor: "#FFAF9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD89D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 334.266,
    y1: 76.5825,
    x2: 334.266,
    y2: 135.545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD89D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAF9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 349.021,
    y1: 51.6653,
    x2: 296.366,
    y2: 97.9499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDAE49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.860966,
    stopColor: "#FF988E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 456,
    height: 547,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgLogin);
export default __webpack_public_path__ + "static/media/img_login.3d2939ab9caf3f965b554b734b0609e4.svg";
export { ForwardRef as ReactComponent };